import { asyncFetchData } from '../utils/fetch-data.js'
import { _query } from '../utils/query.js'
import InviteAjaxBoxContainer, { inviteBox } from './referral-template.js'
import copyToClipboard from '../utils/copy-to-clipboard.js'
import { swalOption } from './swal-opt.js'
import { btnLoadingStart, btnLoadingDone } from './loading.js'
import { __sendVisit } from './send-visit.js'

async function clearForm () {
	const {
		referralSourceSpreadMsgInOrderSummary
	} = await asyncFetchData(`/store/order/get-referral-info/order/${orderId}`)

	const form = _query('#Referral--Form').classList.remove('was-validated')
	const name = _query('#ReferralName').value = ''
	const to = _query('#ReferralEmail').value = ''
	const content = _query('#ReferralEmailContent').value = referralSourceSpreadMsgInOrderSummary
	const sendMeCopyElement = _query('#sendMeCopy')
	const sendMeCopy = sendMeCopyElement.value = 0
	const from = _query('#MyEmail').value = ''
	if (sendMeCopyElement.checked) {
		await _query('#sendMeCopy').click()
	}
}

export async function ajaxSubmitInvite (orderId, inPage) {
	try {
		const form = _query('#Referral--Form')
		const name = _query('#ReferralName').value
		const to = _query('#ReferralEmail').value
		const content = _query('#ReferralEmailContent').value
		const sendMeCopy = _query('#sendMeCopy').value
		const from = _query('#MyEmail').value
		const data = {
			name,
			to,
			content,
			sendMeCopy,
			from,
			orderId
		}
		if (!form.checkValidity()) {
			// event.preventDefault()
			// event.stopPropagation()
		} else {
			await btnLoadingStart('.Orange--PrimaryBtn')

			const result = await asyncFetchData('/referral/index/ajax-submit-invite', data)
			if (result.status === 1) {
				if (inPage) {
					__sendVisit({
						category: 'referral',
						subCategory: 'referFriend',
						label: 'page',
						value: 'Refer Page'
					  })
				} else {
					__sendVisit({
						category: 'receipt',
						subCategory: 'referFriend',
						label: 'page',
						value: 'Order Summary Page'
					  })
				}
				// if (!inPage) {
				// 	Swal.close()
				// }
				Swal.close()
				Swal.fire(swalOption(result.message, true, true, undefined, 'OK', 'referral_ajaxSubmitInvite')).then(res => {
					// if (inPage) window.location.reload(true)
					if (inPage) clearForm(orderId)
				})
				btnLoadingDone('.Orange--PrimaryBtn')
				// if (btn) btn.classList.remove('disabled')
			} else {
				// Swal.fire(swalOption(result.message, true, true))
				alert(result.message)
				// btn.classList.remove('disabled')
				btnLoadingDone('.Orange--PrimaryBtn')
			}
		}

		// console.debug(`validateForms`)

		form.classList.add('was-validated')

	} catch (error) {
		throw new Error(`ajaxSubmitInvite error: ${error}`)
	}
}

function onClickHandler (cb) {
	const expandContent = _query('#MyEmailWrapper')
	const fromField = _query('#MyEmail')
	if (cb.checked) {
		expandContent.style.display = 'block'
		fromField.setAttribute('required', '1')
	} else {
		expandContent.style.display = 'none'
		fromField.removeAttribute('required')
	}
}

export async function fetchReferralContent (orderId) {
	// const {
	// 	referralLabel,
	// 	referralInstruction,
	// 	referralSourceSpreadMsgInOrderSummary,
	// 	moreInfoLink
	// } = await asyncFetchData(`/store/order/get-referral-info/order/${orderId}`)
	const dataDiv = _query('#__visit')
	const referralLabel = dataDiv.getAttribute('data-referral-label')
	const referralInstruction = dataDiv.getAttribute('data-referral-instruction')
	const referralSourceSpreadMsgInOrderSummary = dataDiv.getAttribute('data-referral-msg')
	const moreInfoLink = dataDiv.getAttribute('data-referral-link')

	// eslint-disable-next-line new-cap
	const content = await InviteAjaxBoxContainer(orderId, referralLabel, referralInstruction, referralSourceSpreadMsgInOrderSummary, moreInfoLink)
	// const content = await fetchContent('/referral/index/ajax-invite?ajax=1')
	// validationAction()

	return content

}

export async function fetchReferralPageContent (orderId) {
	const {
		referralLabel,
		referralInstruction,
		referralSourceSpreadMsgInOrderSummary,
		moreInfoLink
	} = await asyncFetchData(`/store/order/get-referral-info/order/${orderId}`)
	// const description = await getMeta('og:description')
	// eslint-disable-next-line new-cap
	const content = await inviteBox(orderId, referralLabel, referralInstruction, referralSourceSpreadMsgInOrderSummary, moreInfoLink, true)
	// const content = await fetchContent('/referral/index/ajax-invite?ajax=1')
	_query('#ReferralContent--PlaceHolder').innerHTML = content

}

export function copyOnClickReferral (itemId, inputId = 'copyLinkPlaceHolder') {
	const content = _query('#ReferralEmailContent').value
	const targetInput = document.getElementById(inputId)
	const link = targetInput.getAttribute('data-share-link')
	targetInput.textContent = `${content} ${link}`
	copyToClipboard(targetInput)
	$(itemId)
		.attr('data-original-title', 'Copied to clipboards')
		.tooltip('show')
}


window.onClickHandler = onClickHandler
// window.fetchReferralContent = fetchReferralContent
window.fetchReferralPageContent = fetchReferralPageContent
window.copyOnClickReferral = copyOnClickReferral
